export default {"src":"/_next/static/media/arrw.dda0a528.svg","height":18,"width":28};